import axios from 'axios'
import Router from '@/router/index'
const urls = require('../../url');

//定义fetch函数，config为配置
export function fetch(config) {


  //返回promise对象
  return new Promise((resolve, reject) => {
    //创建axios实例，把基本的配置放进去
    const instance = axios.create({
      //定义请求文件类型
      headers: {
        'Content-Type': config.content,
      },
      // 请求超时
      timeout: 60000,
      //定义请求根目录
      baseURL: urls.restUrl,
      data: config.data
    });

    instance.interceptors.request.use(function (config) {
      config.headers.common['Authorization'] = window.localStorage.getItem('token');
      return config
    }, function (error) {
      return Promise.reject(error)
    });

    instance.interceptors.response.use(function (res) {
      if (res.headers.token) {
        localStorage.setItem('token', res.headers.token);
      }
      return res
    }, function (error) {
      return Promise.reject(error)
    });
    //请求成功后执行的函数
    instance(config).then(res => {
      if(res.status===600){
        notifyFailMsg('登陆信息已过期');
        Router.push({path: '/'})
      }
      resolve(res);
      //失败后执行的函数
    }).catch(err => {
      console.log(err);
      reject(err);
    })
  });
}

// 封装调用的接口 getData
export function getData(url, type, req, content, data) {
  //如果type为空，默认为post方法，也可以自己改成get
  let requestUrl = req ? req : urls.restUrl;
  if (type === '') {
    type = 'post';
  }
  if (!content) {
    content = 'application/json'
  }
  return fetch({
    url: requestUrl + url,
    method: type,
    data: data,
    content: content
  })
}


import {Notification} from 'element-ui';
import {Message} from 'element-ui';

//右下角通知
export function notifyMsg(msg) {
  Notification.success({
    showClose: true,
    message: msg,
    title: msg,
    type: 'success',
    duration: 3000,
    position: 'bottom-right'
  });
}

//右下角通知
export function notifyFailMsg(msg) {
  Notification.error({
    showClose: true,
    message: msg,
    title: msg,
    type: 'success',
    duration: 3000,
    position: 'bottom-right'
  });
}

//中间展示成功通知
export function success(msg) {
  Message.success({
    showClose: true,
    message: msg,
    type: 'success'
  });
}

//中间展示失败通知
export function error(msg) {
  Message.error({
    showClose: true,
    message: msg
  });
}
//日期查询条件
export let dateQuery = {
  shortcuts: [{
    text: '今天',
    onClick(picker) {
      const start = new Date();
      start.setHours(0);
      start.setMinutes(0);
      start.setSeconds(0);
      const end = new Date();
      start.setHours(0)
      end.setHours(0);
      end.setMinutes(0);
      end.setSeconds(0);
      start.setDate(start.getDate() - 1);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '昨天',
    onClick(picker) {
      const start = new Date();
      start.setHours(0);
      start.setMinutes(0);
      start.setSeconds(0);
      const end = new Date();
      start.setHours(0)
      end.setHours(0);
      end.setMinutes(0);
      end.setSeconds(0);
      start.setDate(start.getDate() - 2);
      end.setDate(end.getDate() - 1);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '近三天',
    onClick(picker) {
      const start = new Date();
      start.setHours(0);
      start.setMinutes(0);
      start.setSeconds(0);
      const end = new Date();
      start.setHours(0)
      end.setHours(0);
      end.setMinutes(0);
      end.setSeconds(0);
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一周',
    onClick(picker) {
      const start = new Date();
      start.setHours(0);
      start.setMinutes(0);
      start.setSeconds(0);
      const end = new Date();
      start.setHours(0)
      end.setHours(0);
      end.setMinutes(0);
      end.setSeconds(0);
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const start = new Date();
      start.setHours(0);
      start.setMinutes(0);
      start.setSeconds(0);
      const end = new Date();
      start.setHours(0)
      end.setHours(0);
      end.setMinutes(0);
      end.setSeconds(0);
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      const start = new Date();
      start.setHours(0);
      start.setMinutes(0);
      start.setSeconds(0);
      const end = new Date();
      start.setHours(0)
      end.setHours(0);
      end.setMinutes(0);
      end.setSeconds(0);
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit('pick', [start, end]);
    }
  }]
}


export function reviewTime(row) {
  let dateee = new Date(row).toJSON();
  return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
}



//////////////////
// WEBPACK FOOTER
// ./static/js/axios.js
// module id = null
// module chunks = 